export function dehydrate({
  answered = 0,
  total = 0,
  additionalAnswered = 0,
  additionalTotal = 0,
  draft = 0,
  published = 0,
  datePublished = null,
  lastAnsweredQuestionPath,
}) {
  return {
    answered,
    total,
    additionalAnswered,
    additionalTotal,
    draft,
    published,
    datePublished,
    lastAnsweredQuestionPath,
  }
}

export function dehydrateDiff({
  answered = 0,
  total = 0,
  additionalAnswered = 0,
  additionalTotal = 0,
  draft = 0,
  published = 0,
}) {
  return {
    answered,
    total,
    additionalAnswered,
    additionalTotal,
    draft,
    published,
  }
}
